enum ContactTypeEnum {
    EMAIL = "EMAIL",
    MOBILE = "MOBILE",
}

export default ContactTypeEnum;
